import { useIntl } from 'react-intl';
import { CardContent, Typography } from '@packages/shared';
import { engravingInputMessages } from './messages';
import { moreInformationTypographyProps } from './styles';

export const EngravingMoreInformation = (): React.ReactElement => {
  const format = useIntl().formatMessage;

  return (
    <CardContent sx={{ pb: '0 !important' }}>
      <Typography {...moreInformationTypographyProps}>
        {format(engravingInputMessages.moreInformationP1)}
      </Typography>
      <Typography {...moreInformationTypographyProps}>
        {format(engravingInputMessages.moreInformationP2)}
      </Typography>
      <Typography {...moreInformationTypographyProps}>
        {format(engravingInputMessages.moreInformationP3)}
      </Typography>
      <Typography {...moreInformationTypographyProps}>
        {format(engravingInputMessages.moreInformationP4)}
      </Typography>
    </CardContent>
  );
};
